export default __webpack_public_path__ + "static/media/landing-portrait.7c1eb0a3.jpg";